"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationTree = void 0;
class OperationTree {
    static getTryCatchFinallyHook(_ctx) {
        return this;
    }
    static getPriority() {
        return -1;
    }
    static onTry(ctx) {
        const parent = this.getCurrentOperationFromContext(ctx);
        ctx.sharedContext = parent?.sharedContext || {};
        ctx.parent = parent;
        this.setCurrentOperationToContext(ctx, ctx);
    }
    static onFinally(ctx) {
        return () => {
            this.setCurrentOperationToContext(ctx, ctx.parent);
        };
    }
    static getCurrentOperationFromTrackedClassInstance(classInstance) {
        return classInstance?.currentOperation;
    }
    static getCurrentOperationFromContext(ctx) {
        return ctx.funcThis.currentOperation;
    }
    static setCurrentOperationToContext(ctx, newCurrentOperation) {
        ctx.funcThis.currentOperation = newCurrentOperation;
    }
    static getOperationsStack(ctx) {
        const stack = [];
        let current = ctx;
        while (current) {
            stack.unshift(current);
            current = current.parent;
        }
        return stack;
    }
    static getDecoratorUtils() {
        return {
            getCurrentOperation(classInstance) {
                return classInstance?.currentOperation;
            }
        };
    }
}
exports.OperationTree = OperationTree;
//# sourceMappingURL=OperationTree.js.map